import type { StaticLayerPayload } from "@config";
import { CarouselLibrary, CarouselPdf } from "@library-combos/carousel";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: CarouselLibrary,
  pdf: CarouselPdf,
};

export const Carousel = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
